/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_Q11Inputs */

const en_pc_faq_q11 = /** @type {(inputs: Pc_Faq_Q11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the ArtCraft Launcher?`)
};

const zh_pc_faq_q11 = /** @type {(inputs: Pc_Faq_Q11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ArtCraft Launcher 是什么？`)
};

/**
* | output |
* | --- |
* | "What is the ArtCraft Launcher?" |
*
* @param {Pc_Faq_Q11Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_q11 = /** @type {((inputs?: Pc_Faq_Q11Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_Q11Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_q11(inputs)
	return zh_pc_faq_q11(inputs)
});
export { pc_faq_q11 as "pc.faq.q11" }